import { ISODatetime } from '@models/date';
import { z } from 'zod';

export type Maintenance = z.infer<typeof Maintenance>;

export const Maintenance = z.object({
  enabled: z.boolean().nullish(),
  start: ISODatetime.nullish(),
  end: ISODatetime.nullish(),
});
